import { ButtonGroup, Modal } from 'slab'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function PaymentsInfoModal ({ open, onOpenChange }: Props) {
  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Body>
        <Modal.Title>How payments work</Modal.Title>
        <p>
          Your Thatch balance is applied first when you buy something. If it doesn't cover the full price, you can charge the rest to your personal card at checkout.
        </p>
        <p>
          No balance? No problem. You can pay entirely with your personal credit card, then submit a reimbursement when your balance renews.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Modal.Button>Got it</Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
